import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/admin/login`, { email: email.trim(), password });
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_name', res.data.name);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-sm bg-[#D4AF37] flex items-center justify-center mx-auto mb-4">
            <Lock size={24} className="text-black" />
          </div>
          <h1 className="font-playfair text-2xl text-white mb-2">Admin Portal</h1>
          <p className="text-white/40 font-manrope text-sm">Dream Room Theaters Management</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#111113] border border-white/5 rounded-sm p-8 space-y-6" data-testid="admin-login-form">
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 rounded-sm p-3 font-manrope text-center" data-testid="login-error">
              <p className="text-red-400 text-sm">{error}</p>
              <p className="text-white/40 text-xs mt-2">
                Trouble signing in? Email{' '}
                <a href="mailto:info@dreamroomtheaters.com" className="text-[#D4AF37] underline" data-testid="admin-login-help-link">info@dreamroomtheaters.com</a>
              </p>
            </div>
          )}

          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-manrope mb-2 block">Email</label>
            <input
              type="email" required
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] focus:outline-none px-0 py-3 text-white placeholder:text-white/20 font-manrope transition-colors"
              placeholder="admin@dreamroomtheaters.com"
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-manrope mb-2 block">Password</label>
            <input
              type="password" required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] focus:outline-none px-0 py-3 text-white placeholder:text-white/20 font-manrope transition-colors"
              placeholder="Enter password"
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-[#D4AF37] text-black hover:bg-[#C5A059] uppercase tracking-widest px-8 py-4 rounded-sm font-manrope font-bold text-sm transition-all duration-300 disabled:opacity-50"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'Sign In'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
